<template>
  <div :class="['navbar--fixed', isRestaurant && 'is-restaurant', isRestaurantDetail && 'is-restaurant']">
    <div class="container--navbar navbar">
      <NavbarSearchInput
        v-if="searchBar.active"
        @search-text-change="searchGlobal"
        @close="searchBarActiveHasChange"
      />

      <mq-layout
        :mq="['lg', 'xl']"
        :class="[
          searchBar.active
            ? 'container--navbar__hidden'
            : 'container--navbar__hidden container--navbar__showing',
        ]"
      >
        <NavbarDesktop
          v-if="!searchBar.active"
          :navbar="navbar"
          :selected-action-values="getSelectedActionValues"
          :css-style="cssStyle"
          @action-bar-value-has-change="actionBarValueHasChange"
          @search-bar-active-has-change="searchBarActiveHasChange"
        />
      </mq-layout>

      <mq-layout :mq="['sm', 'md']">
        <NavbarMobile
          v-if="!searchBar.active"
          :navbar="navbar"
          :selected-action-values="getSelectedActionValues"
          :css-style="cssStyle"
          @action-bar-value-has-change="actionBarValueHasChange"
          @search-bar-active-has-change="searchBarActiveHasChange"
        />
      </mq-layout>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { isEmpty, map, startsWith, keyBy, head } from "@/utils/lodash";
import cssVariables from "@/assets/variables.scss";
import logo from "@/assets/images/logo/logo-white.png";
import NavbarDesktop from "@/components/navbar/navbar-desktop.vue";
import NavbarMobile from "@/components/navbar/navbar-mobile.vue";
import NavbarSearchInput from "@/components/navbar/navbar-search-input.vue";
import Store from '@/store';
import userApi from "@/api/user";


const actionBarTypeCodes = {
  LANGUAGE: "LANGUAGE",
  COUNTRY: "COUNTRY",
  TAX: "TAX",
};

export default {
  components: {
    NavbarDesktop,
    NavbarMobile,
    NavbarSearchInput,
  },
  data() {
    return {
      selectedLanguageCode: "FR",
      countryCode: '',
      searchBar: {
        active: false,
      },
      cssStyle: {
        backgroundColor: "transparent",
        textColor: cssVariables.colorOnPrimary,
        activeTextColor: cssVariables.colorOnPrimary,
        subMenuGroupColors: [
          `${cssVariables.colorPrimary}`,
          // TODO: Map this color as a variable into @/assets/variables.scss
          // `${cssVariables.colorPrimary}`,
        ],
      },
    };
  },
  computed: {
    ...mapState("configuration", ["actionBar"]),
    ...mapState("user", ["user"]),
    ...mapGetters("user", ["isLoggedIn"]),

    navbar() {
      return {
        logo: {
          path: "/",
          src: logo,
        },
        menus: this.getFormattedMenus(),
        actionBar: this.getFormattedActionBar(),
      };
    },
    getSelectedActionValues() {
      return {
        language: this.selectedLanguageCode,
        country: this.actionBar.country,
        tax: this.actionBar.tax,
      };
    },
    isRestaurant(){
      return this.$route && this.$route.fullPath.indexOf('inventory=') > -1 ? true : false;
    },
    isRestaurantDetail() {
      return this.$route && this.$route.fullPath.indexOf('productType=') > -1  ? true : false;
    }
  },
  mounted() {
    localStorage.setItem("countryCode", "QC");
    this.initializeCountry();
    if (
      localStorage.getItem("setLangRequestValue") !== null &&
      localStorage.getItem("setLangCode") !== null
    ) {
      var code = localStorage.getItem("setLangCode");
      var requestValue = localStorage.getItem("setLangRequestValue");
      this.setDefaultLang(code, requestValue);
    }
      this.$root.$on("changeProductPage", (lang) => {
        
        let country = keyBy(
          head(this.$i18n.t("common.navbar.actionBar.country.subMenuGroups"))
            .items,
          "code"
        )["QC"];
        if (lang.code == "EN") {
          country = keyBy(
            head(this.$i18n.t("common.navbar.actionBar.country.subMenuGroups"))
              .items,
            "code"
          )["ON"];
        }
        this.updateCountryActions(country);
      });
  },
  watch:{
    $route() {
      this.initializeCountry();
    },
  },
  methods: {
    ...mapActions("configuration", ["setActionBarCountry", "setActionBarTax"]),
    ...mapActions("user", ["logout"]),
    ...mapActions("shoppingCart", ["updateShoppingCart", "fetchShoppingCart"]),
    ...mapActions("product", ["fetchProductsByPuid"]),

    initializeCountry() {
      const countryPath = this.$route.path || "/";
      this.countryCode = countryPath.slice(1).toUpperCase();

      if (this.countryCode) {
        localStorage.setItem("countryCode", this.actionBar.country);
      }
        let country = keyBy(
        head(this.$i18n.t("common.navbar.actionBar.country.subMenuGroups"))
          .items,
        "code"
      )[this.countryCode];
        
        this.updateCountryActions(country);
      // }
    },
    formatKeyValueQueryString(parameters) {
      return map(
        parameters,
        (parameter) => `${parameter.key}=${parameter.value}`
      ).join("&");
    },
    getFormattedMenus() {
      const navbarRouteIndexedByView = {
        BOUTIQUE: {
          path: "/products?",
        },
        PRODUCTS: {
          path: "/products",
        },
        PROVIDERS: {
          path: "/providers",
          parameters: [
            {
              key: "type",
              value: this.actionBar.country,
            },
          ],
        },
        CLIENTS: {
          path: "/account",
        },
        BLOG: {
          path: "/blogs",
        },
        ABONNEMENT: {},
      };

      return map(this.$i18n.t("common.navbar.menus"), (menu) => {
        let path;
        let subMenuGroups;

        if (!isEmpty(navbarRouteIndexedByView[menu.code].parameters)) {
          path = `${
            navbarRouteIndexedByView[menu.code].path
          }?${this.formatKeyValueQueryString(
            navbarRouteIndexedByView[menu.code].parameters
          )}`;
        } else {
          path = navbarRouteIndexedByView[menu.code].path;
        }

        if (!isEmpty(menu.subMenuGroups)) {
          if (menu.subMenuGroups.length > 4) {
            throw new Error(
              "@/components/navbar/navbar.vue : A sub menu groups cannot be bigger than 4 to prevent a division by 5 (24 / 5)"
            );
          }

          subMenuGroups = map(menu.subMenuGroups, (subMenuGroup) => ({
            ...subMenuGroup,
            items: map(subMenuGroup.items, (item) => ({
              ...item,
              path:
                item.type == "single"
                  ? `${item.path}`
                  : `${
                      navbarRouteIndexedByView[menu.code].path
                    }?${this.formatKeyValueQueryString(item.inventories)}`,
            })),
          }));
        }

        return {
          ...menu,
          path,
          subMenuGroups,
        };
      });
    },
    getFormattedActionBar() {
      return [
        {
          type: actionBarTypeCodes.LANGUAGE,
          model: this.selectedLanguageCode,
          ...this.$i18n.t("common.navbar.actionBar.language"),
        },
        {
          type: actionBarTypeCodes.COUNTRY,
          model: this.actionBar.country,
          ...this.$i18n.t("common.navbar.actionBar.country"),
        },
        {
          type: actionBarTypeCodes.TAX,
          model: this.actionBar.tax,
          ...this.$i18n.t("common.navbar.actionBar.tax"),
        },
      ];
    },
    updateLanguageActions(language) {
      localStorage.setItem("setLangCode", language.code);
      localStorage.setItem("setLangRequestValue", language.requestValue);
      this.selectedLanguageCode = language.code;
      this.$i18n.locale = language.requestValue;
      this.$root.$emit("chanLang", this.$i18n.locale);
    },
    updateCountryActions(country) {
       if (country && country.code) {
         localStorage.setItem("countryCode", country.code);
         this.$root.$emit("chancountryCode", country.code);
       }
      
      this.setActionBarCountry({ country });
      if (
        startsWith(this.$router.currentRoute.fullPath, "/providers") &&
        this.$router.currentRoute.query.type !== country && country.code
      ) {
        this.$router.push({
          query: {
            ...this.$route.query,
            type: country.code,
          },
        });
      }
    },
    updateTaxActions(tax) {
      this.setActionBarTax({ tax });
      this.$root.$emit("changeTax", tax);
    },
    actionBarValueHasChange({ value, type }) {
      const getCountryCode = localStorage.getItem('actualCountryCode');
      if (type === actionBarTypeCodes.LANGUAGE) {
        this.updateLanguageActions(value);
      }

      if (type === actionBarTypeCodes.COUNTRY) {
        if(this.isLoggedIn == true) {
          if ((getCountryCode == 'QC' && value.code == 'ON') || (getCountryCode == 'ON' && value.code == 'QC')) {
            this.handleLogout();
          }
        }
        if (this.isLoggedIn == false) {
          this.updateCountryActions(value);
          if(getCountryCode == value.code) {
            this.updateShoppingCartUser().then(() => {
                  if(this.user && this.user.passwordExpired == true){
                    this.$router.push('/reset-password');
                  }
                  else if (this.$route.query.redirect) {
                    this.$router.push(this.$route.query.redirect);
                  } else {
                    const getProducts = JSON.parse(localStorage.getItem('cartProducts'))
                    const puids = map(getProducts, (p) => p.puid)
                    this.fetchProductsByPuid({
                      puids,
                    })
                    this.$router.push('/account');
                  }
                });
                userApi.findById(JSON.parse(sessionStorage.user).user.id).then((user) => {
                  Store.dispatch("user/setUserProfile", user);
                });
          }
        }
      }

      if (type === actionBarTypeCodes.TAX) {
        this.updateTaxActions(value);
      }
    },
    updateShoppingCartUser() {
      const vm = this;
      const getId = JSON.parse(sessionStorage.getItem("user"));
      const user = {
        id: getId.id,
      };
      if (getId) {
        return Promise.resolve(
          this.fetchShoppingCart({
            id: getId.id,
          })
            .then(() => {
              const shoppingCart = {
                lockVersion: vm.shoppingCart.lockVersion,
                user,
                products: vm.shoppingCart.products,
              };
              const cartId = user.id
              vm.updateShoppingCart({
                id: cartId,
                shoppingCart,
              });
            })
            .catch((error) => {
              console.log(error);
            })
        );
      }
      return Promise.resolve();
    },
    searchGlobal({ text }) {
      this.$router
        .push({
          path: "/global-search",
          query: {
            t: text,
          },
        })
        .catch(() => {});
      this.searchBarActiveHasChange();
    },
    searchBarActiveHasChange() {
      this.searchBar.active = !this.searchBar.active;
    },
    setDefaultLang(code, requestValue) {
      this.selectedLanguageCode = code;
      this.$i18n.locale = requestValue;
    },
    handleLogout() {
      Store.dispatch('user/logout');
      Store.dispatch('shoppingCart/emptyShoppingCart');
      Store.dispatch('user/createTempUser');
      
      this.logout();
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
.navbar--fixed {
  background-color: $color-primary;
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  border-bottom: solid 2px rgba(255, 255, 255, 0.2) !important;
}
.navbar {
  height: 50px;
  // background-color: $color-primary;
  width: 100%;
}
.container--navbar {
  min-width: $container-min-width;

  // sm -
  @media screen and (max-width: $media-md) {
    max-width: $container-min-width;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    max-width: $container-max-width-md;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    max-width: $media-lg;
  }

  margin-left: auto;
  margin-right: auto;
}
.container--navbar__hidden {
  transform: translateX(-100vw);
  transition: all 0.3s;
}
.container--navbar__showing {
  transform: translateX(0);
}
</style>
